<template>
<div class="menuBody" >
   <OrganizationalStructure @AllData="getMsg"  />
        <BillShareDepartmentDialog :param="diaLogData" @Visible="Visible" ref="BillShareDepartmentDialog"/>
    <div class="menuTool" style="width:100%;">
      <el-card class="box-card">
        <el-row :gutter="10">
            <div style="width:100%;height:30px;margin-top:10px;border-bottom:1px solid rgba(234, 237, 241, 1);margin-bottom:15px">
                共享部门列表  
            </div>
             <div style="width:200px;float:left;margin-right:30px">
                 <el-input placeholder="请输入领用部门名称" size="small"     v-model="groupName"></el-input>
            </div>
               <div style="width:200px;float:left;margin-right:30px">
                 <el-input placeholder="请输入共享部门名称" size="small"     v-model="groupNameT"></el-input>
            </div>
             <div style="float:left;">
                <el-button type="primary" size="small" plain  style="background: #246CE5;color:#fff;border-radius:9px;" v-Jurisdiction="'expense:web:bs:bsDs:selectListPage'" @click="Inquire()">查询</el-button>
            </div>
             <div style="float:right;">
               <el-button type="primary"  size="small" plain  style="background: #246CE5;color:#fff;border-radius:9px;" v-Jurisdiction="'expense:web:bs:bsDs:save'" @click="PropertyAdd()">共享部门添加</el-button>
            </div>

    <el-table  :data="tableData"  tooltip-effect="light"  v-loading="loading"  style="overflow-y: scroll;float:right;margin-top:30px" 
  row-key="id"   :header-cell-style="{background:'#eef1f6',color:'#606266','font-weight': '600','height':'45px','text-align':'left'}" 
      :cell-style="{'text-align':'left'}"  :default-expand-all="false" :stripe="true" :tree-props="{children: 'children'}">
    <el-table-column show-overflow-tooltip prop="takeOfficeName" label="领用部门名称" ></el-table-column>
    <el-table-column show-overflow-tooltip prop="shareOfficeName" label="共享部门名称" ></el-table-column>
    <el-table-column show-overflow-tooltip prop="remarks" label="备注"></el-table-column>
    <el-table-column  fixed="right" label="操作">
     <template slot-scope="scope">
          <el-button @click="editMenu(scope.row)" type="primary" icon="el-icon-edit" circle size="small" v-Jurisdiction="'expense:web:bs:bsDs:save'" title="修改"></el-button>
          <el-button @click="delMenu(scope.row)" type="danger" icon="el-icon-delete" circle size="small" v-Jurisdiction="'expense:web:bs:bsDs:delete'" title="删除"  v-debounce></el-button>
        </template>
    </el-table-column>
  </el-table>
      <el-pagination
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="currentPage"
      :page-sizes="[10, 20, 30, 40]"
      layout="total, sizes, prev, pager, next, jumper"
      :total="total"
      style="float:right;margin-top:25px">
    </el-pagination>

        </el-row>
      </el-card>
    </div>
  </div>
</template>

<script>
import BillShareDepartmentDialog from "../common/BillShareDepartmentDialog";
import OrganizationalStructure from "../common/OrganizationalStructure.vue";

export default {
  name: "BillShareDepartment",
  components: {BillShareDepartmentDialog,OrganizationalStructure},
  data() {
    return {
 
      total:0,
      loading:false,
        pagesize:10,//每页的数据条数
        currentPage:1,//默认开始页面
        groupNum:"",
        groupName:"",
        UpCourseCode:"",
        amount:[],
        amountval:"",
      tableData: [],
      options: [{
          value: '1',
          label: '是'
        }, {
          value: '0',
          label: '否'
        }],
        value: '',
      diaLogVisible: false,
      diaLogData: {
        diaLogVisible: false,
        diaLogType: '',
        paramObj: {},
        paramList: [],
      },
      AllData:[],
      USERObj:"",
      ProjectMana:"",
      taxRateval:"",
      taxRatelab:"",
      mangroupId:"",
      BillListo:"",
      takeOffice:"",
      takeOfficeName:"",
      groupNameT:"",
    }
  },
  methods: {
    expend(){
    },
    getMsg(data){
      this.loading = true
      this.AllData = data
      this.takeOffice = data.officeId
      this.takeOfficeName = data.officeName
      this.ShareList()
    },
    ShareList(){
      let PageSize = {
        "page":this.currentPage, // 当前页
        "size":this.pagesize,  // 每页大小
        "takeOffice":this.takeOffice,
        "takeOfficeName":this.takeOfficeName,
      }
        this.$http.post(this.$requestUrl.POST_BILLSHARE_LIST,PageSize).then((res) => {
          let data = res.data;
          if (200 === data.code) {
            this.total = data.data.total
            this.tableData = data.data.records;
            this.loading = false
          } else {
            this.$message.error(result.msg)
            this.loading = false
          }
        }).catch(() => {
          this.$message.error(this.$errorMessage.SEVER_ERROR)
        })
    },
    handleSizeChange(val) {
        this.pagesize = val
        this.ShareList()
    },
    handleCurrentChange(val) {
 
        this.currentPage = val
        this.ShareList()
    },
    Inquire(){
      this.loading = true
    let PageSize = {
        "page":this.currentPage, // 当前页
        "size":this.pagesize,  // 每页大小
        "takeOffice":this.takeOffice,
        "takeOfficeName":this.groupName,
        "shareOfficeName":this.groupNameT,
      }
        this.$http.post(this.$requestUrl.POST_BILLSHARE_LIST,PageSize).then((res) => {
          let data = res.data;
 
          if (200 === data.code) {
            this.tableData = data.data.records;
            this.groupNameT = ""
            this.groupName = ""
            this.loading = false
          } else {
            this.$message.error(result.msg)
            this.loading = false
          }
        }).catch(() => {
          this.$message.error(this.$errorMessage.SEVER_ERROR)
          this.loading = false
        })
      
    },
    PropertyAdd(){
            this.$refs.BillShareDepartmentDialog.title = "添加";
            this.$refs.BillShareDepartmentDialog.dialogVisible = true; 
            this.$refs.BillShareDepartmentDialog.optionsT = this.AllData;
          let obj = {
            "mangroupName":"领用部门名称",
            "BillListName":"共享部门名称",
            "remarks":"备注信息",
          }
          let row = {}
          row.obj = obj
          this.$refs.BillShareDepartmentDialog.value = ""
          this.$refs.BillShareDepartmentDialog.billvalue = ""
         this.$refs.BillShareDepartmentDialog.formLabelAlign= row;
    },
    editMenu(row) { // 修改
    let arr = []
    let list = {}
    list.value = row.takeOffice
    list.label = row.takeOfficeName
    list.id = row.id
    arr.push(list)
    let array = []
    array.push(row.shareOfficeName)
      this.$refs.BillShareDepartmentDialog.TreeData = row
      this.$refs.BillShareDepartmentDialog.title = "修改";
      this.$refs.BillShareDepartmentDialog.dialogVisible = true;
      this.$refs.BillShareDepartmentDialog.options = arr;
      this.$refs.BillShareDepartmentDialog.value = row.takeOfficeName;
      this.$refs.BillShareDepartmentDialog.billvalue = array
        let obj = {
            "mangroupName":"领用部门名称",
            "BillListName":"共享部门名称",
            "remarks":"备注信息",
        }
        row.obj = obj

         this.$refs.BillShareDepartmentDialog.formLabelAlign= row;
        },



    delMenu(row){
             this.$confirm('是否确认要删除该部门?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
    this.$http.post(this.$requestUrl.DELETE_BILLSHARE+"?id="+row.id).then((res) => {
        let result = res.data;
        if (200 === result.code) {
          this.ShareList()
             this.$message({
            type: 'success',
            message: '删除成功!'
          });
        }else{
           this.$message({
            type: 'warning',
            message: '删除失败'
          });
        }
      }).catch(() => {
        this.$message.error(this.$errorMessage.SEVER_ERROR)
      })
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          });          
        });
    },
    Visible(data){
      if(data == false){
        this.loading = true
        this.ShareList()
      }
    }

  },
  mounted() {
 
  }
}
</script>

<style lang="scss">
.menuBody {
  width: 100%;
  .menuTool {
    .el-card {
      .el-card__body {
        padding: 10px 20px;
      }
    }

    margin-bottom: 10px;
  }

  .el-table {
    td {
      padding: 5px;
    }

    th {
      padding: 5px;
    }

    .success-row {
      background: #f0f9eb;
    }
  }

}
</style>